
import React from 'react';
import { ReactFlow, Background, Controls, ConnectionMode, Node, Edge } from '@xyflow/react';
import '@xyflow/react/dist/style.css';
import RoleNode from '../RoleNode';
import { SmartBezierEdge } from './SmartBezierEdge';
import { defaultEdgeOptions } from './EdgeOptions';

const nodeTypes = {
  roleNode: RoleNode
};

const edgeTypes = {
  smartBezier: SmartBezierEdge
};

interface ReactFlowContainerProps {
  nodes: Node[];
  edges: Edge[];
  onNodesChange: (changes: any) => void;
  onEdgesChange: (changes: any) => void;
  onConnect: (params: any) => void;
  onEdgeClick: (event: React.MouseEvent, edge: Edge) => void;
  isEditable: boolean;
}

export const ReactFlowContainer = ({
  nodes,
  edges,
  onNodesChange,
  onEdgesChange,
  onConnect,
  onEdgeClick,
  isEditable
}: ReactFlowContainerProps) => {
  return (
    <ReactFlow 
      nodes={nodes} 
      edges={edges} 
      onNodesChange={onNodesChange} 
      onEdgesChange={onEdgesChange} 
      onConnect={onConnect} 
      onEdgeClick={onEdgeClick} 
      nodeTypes={nodeTypes} 
      edgeTypes={edgeTypes} 
      defaultEdgeOptions={defaultEdgeOptions}
      fitView 
      fitViewOptions={{
        padding: 0.2,
        maxZoom: 1.5
      }}
      minZoom={0.1} 
      maxZoom={1.5}
      style={{
        background: 'transparent',
        '--xy-handle-width': '12px',
        '--xy-handle-height': '4px',
        '--xy-handle-color': '#ff0000'
      } as React.CSSProperties}
      connectionMode={ConnectionMode.Loose}
      elevateNodesOnSelect={true}
      proOptions={{ hideAttribution: true }}
      nodesDraggable={isEditable}
      nodesConnectable={isEditable}
      elementsSelectable={isEditable}
    >
      <Background />
      <Controls />
    </ReactFlow>
  );
};
